/* PAGE_SIZES (px @ ~96dpi) */
export const PAGE_SIZES = {
  a4: { width: 794, height: 1123 },
  a5: { width: 559, height: 794 },
  letter: { width: 816, height: 1056 },
  legal: { width: 816, height: 1344 },
};

export const getPagePx = (pageSize, layout) => {
  const base = PAGE_SIZES[pageSize] || PAGE_SIZES.a4;
  return layout === "landscape"
    ? { width: base.height, height: base.width }
    : base;
};

export const NO_INVOICE_HTML =
  '<div class="measure-row py-8 text-center text-slate-500"><div class="text-lg font-medium">No Invoice Details</div><div class="text-sm mt-2">Please provide a rowRenderer to display invoice items</div></div>';

/**
 * Paginate measured rows into pages.
 * rows: Array<{ height: number, html: string }>
 * pagePxHeight: number
 * heights: { headerFirstH, headerOtherH, footerFirstH, footerOtherH, contentTopH, contentBottomH }
 * returns: Array<Array<string>> (pages of html)
 */
export function paginateRows(rows, pagePxHeight, heights) {
  const {
    headerFirstH = 60,
    headerOtherH = 30,
    footerFirstH = 80,
    footerOtherH = 40,
    contentTopH = 0,
    contentBottomH = 40,
  } = heights || {};

  if (!rows || rows.length === 0) {
    return [[NO_INVOICE_HTML]];
  }

  const usableFirst = pagePxHeight - headerFirstH - footerFirstH - contentTopH - 20;
  const usableOther = pagePxHeight - headerOtherH - footerOtherH - 20;
  const usableLast = pagePxHeight - headerOtherH - footerFirstH - contentBottomH - 20;

  const children = rows;
  const newPages = [];

  let i = 0;
  let cur = [];
  let curH = 0;
  while (i < children.length) {
    const h = children[i].height;
    if (cur.length > 0 && curH + h > usableFirst) break;
    cur.push(children[i].html);
    curH += h;
    i++;
  }

  if (i === children.length && contentBottomH > 0) {
    const singleUsable =
      pagePxHeight - headerFirstH - footerFirstH - contentTopH - contentBottomH - 50;
    while (curH > singleUsable && cur.length > 0) {
      const lastIndex = i - 1;
      const lastEl = children[lastIndex];
      curH -= lastEl.height;
      cur.pop();
      i--;
    }
  }
  if (cur.length) newPages.push(cur);

  while (i < children.length) {
    const pageArr = [];
    let pageSum = 0;

    let isLikelyLastPage = false;
    let tempSum = 0;
    for (let j = i; j < children.length; j++) {
      tempSum += children[j].height;
      if (tempSum > usableOther) {
        break;
      }
      if (j === children.length - 1) {
        isLikelyLastPage = true;
      }
    }

    const currentUsable = isLikelyLastPage ? usableLast : usableOther;

    while (i < children.length) {
      const h = children[i].height;
      if (pageArr.length > 0 && pageSum + h > currentUsable) break;
      pageArr.push(children[i].html);
      pageSum += h;
      i++;
    }
    if (pageArr.length === 0 && i < children.length) {
      pageArr.push(children[i].html);
      i++;
    }
    if (pageArr.length) newPages.push(pageArr);
  }

  return newPages;
}